import * as React from "react";
import { SVGProps } from "react";

const Quant = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 451 488" {...props}>
    <path d="m102.3 29 124.1 145.4 83.3-49S209.2-9 182.4.5C157.2 10.1 102.3 29 102.3 29zm210.5 96.4s18.9-33.2 28.3-77.5c0 0 94.3 37.9 58.1 132.8l-86.4-55.3z" />
    <path d="m399.2 180.8 7.9 99.6 36.1-4.7s9.4-3.2 7.9-20.5c-1.6-19-4.7-58.5-4.7-58.5s1.6-9.5-20.4-12.6c-26.8-4.9-26.8-3.3-26.8-3.3zm7.8 99.6-72.3 58.5 33 64.8s7.9 25.3 31.4-3.2c22-28.5 31.4-33.2 29.8-50.6-1.4-17.4-6.2-58.5-21.9-69.5zm-73.8 58.4-99-44.3L147.8 470s-6.3 12.6 15.7 14.2c22 3.2 58.1 11.1 77-7.9 18.9-17.3 92.7-137.5 92.7-137.5zm-99-45.8-9.4-117-213.7 14.3s-12.6 1.6-11 25.3C1.7 247.2 4.8 282 4.8 282s-1.6 14.2 26.7 15.8c28.3 1.5 199.6 1.5 202.7-4.8z" />
  </svg>
);

export default Quant;
